import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const PondList = Loadable(lazy(() => import("./PondList")));
const PondForm = Loadable(lazy(() => import("./PondForm")));

const pondRoutes = [
  {
    path: "/Pond/PondList",
    element: <PondList />,
    permission: PERMISSIONS.Ponds.Menu,
  },
  {
    path: "/Pond/PondForm",
    element: <PondForm />,
  },
  {
    path: "/Pond/PondForm/:pondId",
    element: <PondForm />,
  },
];

export default pondRoutes;
